import {
  useEventSignalReceivedSubscription,
  EventSignalReceivedSubscriptionResult,
  SignalCommand
} from 'graphql/generated'

type T = EventSignalReceivedSubscriptionResult['eventSignalReceived']

function useEventSignalHandler(
  eventId: string,
  handler: CallbackWithParam<T>,
  commands?: SignalCommand[]
) {
  useEventSignalReceivedSubscription({
    variables: {
      eventId
    },
    onData: ({ data }) => {
      if (!data) {
        return
      }

      const signal = data.data?.eventSignalReceived
      if (!signal) {
        return
      }
      if (!commands || commands.includes(signal.command)) {
        handler(signal)
      }
    }
  })
}

export default useEventSignalHandler
